"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("@trs/utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelectNew = _interopRequireWildcard(require("react-select-new"));
var _Select = _interopRequireDefault(require("./Select.style"));
var _InputError = _interopRequireDefault(require("../../errors/InputError"));
var _components = require("./components");
var _helpers = require("./helpers");
var _excluded = ["ariaLabel", "value", "onChange", "id", "error", "options", "className", "components", "placeholder", "isSimpleValue", "disabled", "width", "labelKey", "valueKey", "filters", "isMulti", "isClearable"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var SelectV2 = function SelectV2(_ref) {
  var ariaLabel = _ref.ariaLabel,
    value = _ref.value,
    _onChange = _ref.onChange,
    id = _ref.id,
    error = _ref.error,
    options = _ref.options,
    className = _ref.className,
    components = _ref.components,
    placeholder = _ref.placeholder,
    isSimpleValue = _ref.isSimpleValue,
    disabled = _ref.disabled,
    width = _ref.width,
    labelKey = _ref.labelKey,
    valueKey = _ref.valueKey,
    filters = _ref.filters,
    isMulti = _ref.isMulti,
    isClearable = _ref.isClearable,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    className: "select-wrapper",
    width: width,
    hasError: !(0, _utils.isBlank)(error)
  }, /*#__PURE__*/_react["default"].createElement(_reactSelectNew["default"], _extends({
    classNamePrefix: "select-component",
    autoComplete: "off",
    value: (0, _helpers.getValue)(value, isSimpleValue, options),
    onChange: function onChange(e) {
      _onChange(e);
    },
    placeholder: placeholder,
    "aria-label": ariaLabel || placeholder,
    id: id,
    className: className,
    options: options,
    isMulti: isMulti,
    isClearable: isClearable,
    components: _objectSpread({
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      Option: _components.Option,
      SingleValue: _components.SelectedItem,
      MultiValueLabel: _components.MultiValueLabel,
      MultiValueRemove: _components.MultiValueRemove
    }, components),
    isDisabled: disabled,
    filterOption: (0, _reactSelectNew.createFilter)(filters)
  }, (0, _helpers.getOptionsDataProps)(labelKey, valueKey), otherProps)), error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    message: error,
    id: "".concat(id, "Error")
  }));
};
SelectV2.defaultProps = {
  value: null,
  ariaLabel: null,
  id: 'react-select-id',
  className: 'react-select-element',
  error: null,
  options: [],
  components: {},
  placeholder: '',
  isSimpleValue: false,
  disabled: false,
  width: '',
  labelKey: '',
  valueKey: '',
  filters: null,
  isMulti: false,
  isClearable: false
};
SelectV2.propTypes = {
  components: _propTypes["default"].shape({}),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  error: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].array]),
  ariaLabel: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string,
  className: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  isSimpleValue: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  width: _propTypes["default"].string,
  labelKey: _propTypes["default"].string,
  valueKey: _propTypes["default"].string,
  filters: _propTypes["default"].shape({}),
  isMulti: _propTypes["default"].bool,
  isClearable: _propTypes["default"].bool
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SelectV2);